import { UploadFileButton } from '@/ui/features/chat/components/UploadFileButton';
import { ChatDocument } from '@/store';
import { orderChatDocumentsFailedFirst } from '../utils/orderChatDocuments';

interface DocumentsListProps {
  documents: ChatDocument[];
  onDeleteFile: (documentId: string) => void;
}

export const DocumentsList = ({ documents, onDeleteFile }: DocumentsListProps) => {
  const orderedDocuments = orderChatDocumentsFailedFirst(documents);

  return (
    <>
      {orderedDocuments.map(({ documentId, documentName, status, error }) => (
        <UploadFileButton
          key={documentId}
          onRemove={onDeleteFile}
          documentId={documentId}
          documentName={documentName}
          status={status}
          error={error}
        />
      ))}
    </>
  );
};
